import { ReactNode, useEffect } from "react";

interface BottomSheetPopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  closeOnBackdrop?: boolean;
}

const BottomSheetPopup = ({
  isOpen,
  onClose,
  children,
  closeOnBackdrop = true,
}: BottomSheetPopupProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] flex flex-col justify-end">
      <div
        className="absolute inset-0 bg-black/50 transition-opacity duration-300"
        onClick={closeOnBackdrop ? onClose : undefined}
        aria-hidden
      />

      <div
        className="relative w-full max-w-[100vw] mx-auto bg-white rounded-t-[60px] shadow-2xl z-10 animate-slide-up"
        role="dialog"
        aria-modal="true"
      >
        <div className="pt-3 pb-3 flex justify-center">
          <div
            className="w-12 h-1.5 rounded-full bg-[#B8B8B8] shrink-0"
            aria-hidden
          />
        </div>
        <div className="relative flex items-center pb-8 px-6">

          <button
            type="button"
            onClick={onClose}
            className="relative z-10 rounded-full bg-[rgba(128,126,125,0.12)] transition-colors text-black"
            aria-label="Close"
          >
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.3433 18.3438L29.657 29.6575M29.6567 18.3438L18.343 29.6575" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>

        <div className="px-6 pb-9">{children}</div>
      </div>
    </div>
  );
};

export default BottomSheetPopup;
